import Vue from 'vue';
import Router from 'vue-router';
import UserService from './services/user.service';
import asyncWrapper from './utils/asyncWrapper';

Vue.use(Router);

const Templates = () => import(/* webpackChunkName: "bundle" */ './components/Templates/Templates');
const PrivateTemplates = () => import(/* webpackChunkName: "bundle" */ './components/PrivateTemplates/PrivateTemplates');
const Environments = () => import(/* webpackChunkName: "bundle" */ './components/Environments/Environments');
const Settings = () => import(/* webpackChunkName: "bundle" */ './components/Settings/Settings');
const SSH = () => import(/* webpackChunkName: "bundle" */ './components/Settings/Content/SSH/SSH');
const Docs = () => import(/* webpackChunkName: "bundle" */ './components/Settings/Content/Docs/Docs');
const RunEnvironment = () => import(/* webpackChunkName: "bundle" */ './components/Environments/Run/EnvironmentRun');
const ConnectedEnvironmentRun = () => import(/* webpackChunkName: "bundle" */ './components/Environments/Run/ConnectedWrapper');
const Details = () => import(/* webpackChunkName: "bundle" */ './components/Environments/Details/Details');
const ConnectedEnvironmentDetails = () => import(/* webpackChunkName: "bundle" */ './components/Environments/Details/ConnectedEnvironmentDetails');
const Signup = () => import(/* webpackChunkName: "bundle" */ './components/Auth/Signup');
const Login = () => import(/* webpackChunkName: "bundle" */ './components/Auth/Login');
const Verify = () => import(/* webpackChunkName: "bundle" */ './components/Auth/Verify');
const ForgotPassword = () => import(/* webpackChunkName: "bundle" */ './components/Auth/ForgotPassword');
const ForgotPasswordSubmit = () => import(/* webpackChunkName: "bundle" */ './components/Auth/ForgotPasswordSubmit');

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/templates', component: Templates, meta: { title: 'PSC Multicloud Platform - template library' } },
    { path: '/my-templates', component: PrivateTemplates, meta: { title: 'PSC Multicloud Platform - my templates library' } },
    { path: '/environments', component: Environments, meta: { title: 'PSC Multicloud Platform - environments library' } },
    { path: '/environments/:id/run', component: RunEnvironment, meta: { title: 'PSC Multicloud Platform - create new environment' } },
    { path: '/environments/:id/run/connected', component: ConnectedEnvironmentRun, meta: { title: 'PSC Multicloud Platform - create new connected environment' } },
    { path: '/environments/:id/details', component: Details, meta: { title: 'PSC Multicloud Platform - environment details' } },
    { path: '/environments/connected/:id/details', component: ConnectedEnvironmentDetails, meta: { title: 'PSC Multicloud Platform - connected environment details' } },
    {
      path: '/settings', component: Settings, meta: { title: 'PSC Multicloud Platform - settings' },
      children: [
        {
          path: 'ssh',
          component: SSH,
          meta: { title: 'PSC Multicloud Platform - settings - SSH' }
        },
        {
          path: 'docs',
          component: Docs,
          meta: { title: 'PSC Multicloud Platform - settings - Docs' }
        }
      ]
    },
    { path: '/signup', component: Signup, meta: { public: true, onlyWhenLoggedOut: true, title: 'PSC Multicloud Platform - sign up' } },
    { path: '/login', component: Login, meta: { public: true, onlyWhenLoggedOut: true, title: 'PSC Multicloud Platform - log in' } },
    { path: '/signup/verify', component: Verify, meta: { public: true, onlyWhenLoggedOut: true, title: 'PSC Multicloud Platform - verify account' } },
    { path: '/password/reset', component: ForgotPassword, meta: { public: true, onlyWhenLoggedOut: true, title: 'PSC Multicloud Platform - reset password' } },
    { path: '/password/reset/confirm', component: ForgotPasswordSubmit, meta: { public: true, onlyWhenLoggedOut: true, title: 'PSC Multicloud Platform - reset password' } },
    { path: '/', redirect: '/environments' },
  ]
});

router.beforeEach(async (to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const isLogged = await asyncWrapper(UserService.checkIfAuthenticated());

  if (!isLogged.result && !isPublic) {
    return next({ path: '/login' });
  }

  if (isLogged.result && onlyWhenLoggedOut) {
    return next('/templates');
  }

  document.title = to.meta.title
  next();
})
export default router;
